// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"d0d7310f","566":"1cb50614"}[chunkId] + ".chunk.css";
};